module.exports = __webpack_public_path__ + "media/images/challenges/sony-talent-league-edition-iii/bg-02-839314b9b6455526a72dc6fe489799ec.png";